export default "__VITE_ASSET__CZlkcqeq__"